module.exports = __webpack_public_path__ + "static/media/md-skip-forward.2e5c16df.svg";